import config from "../config";

const api_url = config.api_url;
const xref_url = config.xref_url;
const defaults = config.defaults;

const requestOptions = (type = 'POST') => {
    return {
        method: type,
        headers: {
            "Content-Type": "application/json"
        }
    }
}

const getIntegrationProfile = () => {
    let options = {
        ...requestOptions('GET')
    }
    return fetch(`${api_url}/integration/fromtoken?token=${sessionStorage.getItem('token')}`, options)
        .then(response => response.json());
}

const getPayerNames = () => {
    let options = {
        ...requestOptions('GET')
    }
    return fetch(`${api_url}/integration/getpayernames?token=${sessionStorage.getItem('token')}`, options)
        .then(response => response.json());
}

const getPayerTypes = () => {
    let options = {
        ...requestOptions('GET')
    }
    return fetch(`${api_url}/integration/getpayertypes?token=${sessionStorage.getItem('token')}`, options)
        .then(response => response.json());
}

const getLevelsOfCare = () => {
    let options = {
        ...requestOptions('GET')
    }
    return fetch(`${api_url}/integration/getlevelsofcare?token=${sessionStorage.getItem('token')}`, options)
        .then(response => response.json());
}

const getPrimarySubstances = () => {
    let options = {
        ...requestOptions('GET')
    }
    return fetch(`${api_url}/integration/getprimarysubstances?token=${sessionStorage.getItem('token')}`, options)
        .then(response => response.json());
}

const createPatient = (patient) => {
    // if country code is already included ignore this
    if(!patient.mobile.includes('+')){
        // american numbers have parenthesis in them
        if(patient.mobile.includes('(') || patient.mobile.includes(')')){
            patient.mobile = `+1${patient.mobile.replace(/\D/g,'')}`;
        }else{
            patient.mobile = `+64${patient.mobile.replace(/\D/g,'')}`;
        }
    }
    let body = {
        ...patient,
        is_api: false,
        token: sessionStorage.getItem('token'),
    }
    let options = {
        ...requestOptions()
    }
    options['body'] = JSON.stringify(body);
    return fetch(`${api_url}/patient/integration`, options)
        .then(response => response.json());
}

const getRace = () => {
    let options = {...requestOptions('GET')}
    return fetch(`${api_url}/integration/getraces?token=${sessionStorage.getItem('token')}`, options).then(res => res.json());
}

const getFullToken = (abToken) => {
    let options = {
        ...requestOptions('GET')
    }
    return fetch(`${xref_url}/abbreviated?ab_token=${abToken}`, options).then(res => res.json());
}

const manageStaffToProfile = (profileId, staffGuid) => {
    let body = {
        staff_guid: staffGuid,
        integration_profile_id: [profileId],
        agency_guid: defaults.agency_guid,
        token: sessionStorage.getItem('token')
    }
    let options = {
        ...requestOptions()
    }
    options['body'] = JSON.stringify(body);
    return fetch(`${api_url}/integration/staff/profile`, options)
        .then(response => response.json());
}

const getStaffOnboardCount = (staffId) => {
    let options = {...requestOptions('GET')}
    return fetch(`${api_url}/staff/onboard/count/ext?token=${sessionStorage.getItem('token')}&staff_id=${staffId}`, options).then(res => res.json());
}

const incrementQEL = (token, opened, completed) => {
    let body = {
        token: token,
        opened: opened,
        completed: completed,
    }
    let options = {
        ...requestOptions('PUT')
    }
    options['body'] = JSON.stringify(body);
    return fetch(`${api_url}/integration/incrementqel`, options)
        .then(response => response.json());
}

export {
    getIntegrationProfile,
    getPayerNames,
    getPayerTypes,
    getLevelsOfCare,
    getPrimarySubstances,
    getRace,
    createPatient,
    getFullToken,
    manageStaffToProfile,
    getStaffOnboardCount,
    incrementQEL
}